import template from './modalEditDelegation.html';
import controller from './modalEditDelegation.controller';
import './modalEditDelegation.scss';

let ModalEditDelegationComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    role: '<',
    module: '<',
    delegation: '<',
    editDelegation: '&',
    onDismiss: '&',
  },
  template,
  controller,
};

export default ModalEditDelegationComponent;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalEditDelegation/modalEditDelegation.component.js